import { render, staticRenderFns } from "./AlertWarningContent.vue?vue&type=template&id=5ff6b42c"
import script from "./AlertWarningContent.vue?vue&type=script&lang=js"
export * from "./AlertWarningContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports